export const TIMER_RESPONSE_SOURCE = {
    GET_CART: "GET_CART",
    UPDATE_CART: "UPDATE_CART",
    PERFORM_UPDATE_CART: "PERFORM_UPDATE_CART",
};
